import Vue from 'vue';
import VueRx from 'vue-rx';
import Vuelidate from 'vuelidate';
import {Observable, Subject, Subscription} from 'rxjs';
import {sync} from 'vuex-router-sync';
import api from '@/common/api';
import timeoutMiddleware from '@/common/middleware/timeout-middleware';
import jwtErrorMiddleware from '@/common/middleware/jwt-error-middleware';
import ApiManager from '@/plugins/api-manager';
import AuthManager from '@/plugins/auth-manager';
import TimezoneManager from '@/plugins/timezone-manager';
import GlobalErrorHandler from '@/common/errors/global-handler';
import RoutingDirectives from '@/plugins/routing-directives';
import CommonUtils from '@/plugins/common-utils';
import Filters from '@/plugins/filters';
import subscriptions from '@/subscriptions';
import '@/components/directives';
import '@/common/helpers/version-logger';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import '@/vendor';
import './registerServiceWorker';
import Recomponents from '@rebilly/recomponents';
import '@rebilly/recomponents/dist/recomponents.css';

Vue.config.productionTip = false;

// bootstrap Rx and its Vue bindings
Vue.use(VueRx, {
    Observable,
    Subscription,
    Subject,
});

// inject validation handlers
Vue.use(Vuelidate);

// inject API manager into components
Vue.use(ApiManager().install, api);

// inject Authorization
Vue.use(AuthManager().install);

// inject timezone handling into components
Vue.use(TimezoneManager().install, {store});

// inject routing utility directives
Vue.use(RoutingDirectives().install);

// inject common utility functions
Vue.use(CommonUtils().install);

// inject filters functions
Vue.use(Filters().install);
Vue.prototype.$filters = Vue.options.filters;

// synchronize the router state into the global store
sync(store, router);

// setup timeout middleware
timeoutMiddleware({store, api});

// setup jwt error middleware
jwtErrorMiddleware({store, api});

// setup Global Errors Handler
Vue.use(GlobalErrorHandler().install, {store});

// add Recomponents
Vue.use(Recomponents);

(async () => {
    store.subscribeAction({
        after: (action) => {
            if (action.type === 'app/login') {
                router.push(store.getters['router/path'] || {name: 'dashboard'});
            } else if (action.type === 'app/logout') {
                router.push({name: 'login'});
            } else if (action.type === 'app/impersonate') {
                // The login failed
                if (store.getters['user.isGuest']) {
                    router.push({name: 'login'});
                }
            }
        },
    });

    store.dispatch('app/initialize', {preInit: true});

    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        router,
        store,
        subscriptions,
        template: '<App/>',
        components: {App},
    });

    // only available during E2E tests
    if (window.Cypress) {
        window.CypressStore = store;
        Vue.config.errorHandler = window.onerror;
    }
})();
